exports.updateLanguage = (language) => {
    return {
        type: "UpdateLanguage",
        payload: { language }
    }
}